import ButtonComponent from "../../components/common/button/Button";
import Modal from "../../components/common/modal/Modal";

const ShowInvalidForecastDetails = ({ openValidationPopup, onClickCloseInvalidForecastModal, invalidRowsRecords }) => {

    const onClickCancel = () => {
        onClickCloseInvalidForecastModal();
    }

    return (
        <div>
            <Modal
                className="UploadExcelModal_cls"
                open={openValidationPopup}
                handleClose={onClickCancel}
                title="Invalid Forecast Details"
                fullWidth={"lg"}
                action={
                    <InvalidForecastDetailsFooter
                        onClickCancel={onClickCancel}
                    />
                }
                content={
                    <InvalidForecastDetailsContent invalidRowsRecords={invalidRowsRecords}
                    />
                }
            />
        </div>
    )
}

const InvalidForecastDetailsFooter = ({ onClickCancel }) => {
    return (
        <div className='btn-wrapper' style={{ display: 'flex', gap: 10 }}>
            <ButtonComponent
                label="Close"
                type="primary"
                maxWidth="80px"
                onClick={onClickCancel}
            />
        </div>
    );
};

const InvalidForecastDetailsContent = ({ invalidRowsRecords }) => {
    return (
        <div className="UploadExcelModalContent_cls">
            <div>
                <p style={{color:'red'}}>The following records failed validation. The updated Forecast Pickup quantity cannot exceed the Open Allocation quantity. Please correct the records before saving.</p>
            </div>
            <div>
                <table className="table table-bordered" style={{ width: '100%' }}>
                    <thead style={{ display: "flex", backgroundColor: "#f2f2f2", textAlign: "left" }}>
                        <tr style={{ display: "flex", border: "1px solid #000", flex: 1 }}>
                            <th style={{ flex: 1, padding: "10px 10px 10px 0px" }}>TCCC Material Number</th>
                            <th style={{ flex: 1, padding: "10px 10px 10px 0px" }}>Supplier ID</th>
                            <th style={{ flex: 1, padding: "10px 10px 10px 0px" }}>Plant Code</th>
                        </tr>
                    </thead>
                    <tbody style={{ textAlign: "left", border: "1px solid #000" }}>
                        {invalidRowsRecords?.map((item, index) => (
                            <tr key={index} style={{ display: "flex", border: "1px solid #000" }}>
                                <td style={{ flex: 1, padding: "10px 10px 10px 0px" }}>{item.tcccMaterialNumber}</td>
                                <td style={{ flex: 1, padding: "10px 10px 10px 0px" }}>{item.supplierId}</td>
                                <td style={{ flex: 1, padding: "10px 10px 10px 0px" }}>{item.plantCode}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default ShowInvalidForecastDetails;
